ScrollHelper = App.load "core::ScrollHelper"

class exports.Contacts_Handler extends Handler

    constructor: (name, data = {}) ->
        super(name, data)

        ## All the child classes will have the same subhandlers in scope
        @subHandlers    =
            "Invite":
                "class": "grower::handlers/contacts/tabs/Invite_Tab_Handler"
            "Confirm":
                "class": "grower::handlers/contacts/tabs/Confirm_Tab_Handler"
            "Contacts":
                "class": "grower::handlers/contacts/tabs/Contacts_Tab_Handler"
            "Add_Permission_Dialog":
                "class": "grower::handlers/contacts/Add_Permission_Dialog"
            "Edit_Permission_Dialog":
                "class": "grower::handlers/contacts/Edit_Permission_Dialog"
            "Remove_Permission_Dialog":
                "class": "grower::handlers/contacts/Remove_Permission_Dialog"
            "View_User_Dialog":
                "class": "grower::handlers/contacts/View_User_Dialog"


    init: () ->
        @layoutSelector = App.sidebar.contentDiv()
        @layoutUrl      = "backend/grower/contacts/load-layout"

        @defaultSub = "Contacts"
        @loadLayout()


    afterLoadLayout: (selector, data) ->
        # add some check on which tab should be selected by def
        sub = @createSubHandler(@defaultSub)

        if sub
            sub.init()

    viewUser: (e, obj, selector) ->
        ths = this
        ths.destroySubHandler('view_user', true)
        ths.viewUserReg(e, $(obj), selector)

    viewUserReg: (e, obj, selector) ->
        ths = this
        e.preventDefault()
        obj.parents('tr').addClass('darken')


        users_id = obj.parents('tr').data('users_id')
        viewR = @createSubHandler('View_User_Dialog', 'view_user')
        if viewR
            viewR.amountOfInfo = 'big'
            viewR.loadLayoutPostOptions = user_id: users_id
            viewR.afterHidden = () ->
                $(".list-table").find('tr[data-users_id="' + users_id + '"]').removeClass('darken')
            viewR.init()
            $('#' + viewR.id).addClass('veiwR_dialog')

    viewUserS: (e, obj, selector) ->
        ths = this
        ths.destroySubHandler('view_user', true)
        ths.viewUserSmall(e, $(obj), selector)

    viewUserSmall: (e, obj, selector) ->
        ths = this
        e.preventDefault()
        obj.parents('tr').addClass('darken')

        users_id = obj.parents('tr').data('users_id')
        viewS = @createSubHandler('View_User_Dialog', 'view_user')
        if viewS
            viewS.amountOfInfo = 'small'
            viewS.loadLayoutPostOptions = user_id: users_id
            viewS.afterHidden = () ->
                obj.parents('tr').removeClass('darken')
                #ths.afterHidden(e,obj,selector,users_id)
            viewS.init()


    tabLoadLayoutCallback: (selector, data) ->
        ths = this
        msgwriter = App.sidebar.messageWriter()
        msgwriter.message_writer('success', 'Loaded!')
        msgwriter.message_writer('hide')


        ## Set Event Listeners For Permission DDM ##
        ths = this
        $(@layoutSelector).find('#addpermission, #editpermission, #removepermission').click (e) ->
            e.preventDefault()

            handler = $(this).data('handler')
            sub = ths.createSubHandler handler
            if sub
                sub.init()


        ## Update the number of Unconfirmed Invites ##
        ls = @parent.layoutSelector
        $.post(
            'backend/grower/contacts/confirmtab/get-numconfirmable-ajax'
            (json) ->
                if(json.data > 0)
                    $(ls).find('.num-confirmable').empty().append("(#{json.data})")
        )


        ## make the table scrollable ##
        App.sidebar.contentDiv().find(".tab-content").resizr()
        table = $(selector).find(".list-table")
        $(selector).find(".table-container").resizr()
        ScrollHelper.make table,
            height: $(selector).find(".table-container").resizr 'size'

        table.find('tbody tr .row-clickable').bind 'click', (e) ->
            table.find('tr').removeClass('darken')
            ths.viewUser e, $(this), selector
